import React from "react";
import { Box, Typography } from "@mui/material";
import { StyledGroupBtn, useStyles } from "../styles";

const WinnerModal = ({ handleDecideWinner, group1, group2 }) => {
  const classes = useStyles();

  return (
    <Box sx={{ mt: 2 }}>
      <Typography sx={{ mb: 2, fontWeight: 700, fontSize: "16px" }}>
        Who won the playoff?
      </Typography>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <StyledGroupBtn
          onClick={() => handleDecideWinner("group1")}
          color="#0000ff"
          className={classes.groupBtn}
        >
          {group1}
        </StyledGroupBtn>
        <StyledGroupBtn
          onClick={() => handleDecideWinner("group2")}
          color="#ff0000"
          className={classes.groupBtn}
        >
          {group2}
        </StyledGroupBtn>
      </Box>
    </Box>
  );
};

export default WinnerModal;
